class Tabs extends HTMLElement {
  constructor() {
    super();
    this.toggles = [...this.querySelectorAll('[data-toggle]')];
    this.collapsibles = [...this.querySelectorAll('[data-content]')];
    this.collapsiblesMobile = [...this.querySelectorAll('[data-tab-menu]')];
    this.togglesMobile = [...this.querySelectorAll('[data-tab-selector]')];
    this.titleOption = [...this.querySelectorAll('[data-title-option]')];
  }

  connectedCallback() {

    this.toggles?.forEach((btn) => {
      const id = btn.dataset.toggle;
      const collapsible = this.collapsibles.find(({ dataset }) => dataset.content === id);
      btn.addEventListener('click', () => {
        this.toggles.forEach((tab)=>{
            tab.classList.remove('active');
        })
        btn.classList.add('active');
        this.titleOption?.forEach((t) => {
          t.innerHTML = btn.text;
        })
        this.collapsiblesMobile.map(( item ) => {
          this.toggleMenu(item);
        });

        // btn.addEventListener('click', () => {
        //   this.toggleMenu(collapsible);
        // });
        this.collapsibles.filter(({ dataset }) => dataset.content !== id)
          .forEach((inactiveCollapsible) => {
            // eslint-disable-next-line no-param-reassign
            inactiveCollapsible.classList.add('hidden');
          });
          collapsible.classList.remove('hidden');
      });

    });

    this.togglesMobile?.forEach((mobileBtn) => {
      const id = mobileBtn.dataset.tabSelector;
      mobileBtn.dataset.tabSelector;
      const collapsible = this.collapsiblesMobile.find(({ dataset }) => dataset.tabMenu === id);

      mobileBtn.addEventListener('click', () => {
        this.toggleMenu(collapsible);
      });
    });

    //DEEP LINK
    let url = window.location.href;
    if (url.indexOf("#") > 0){
      const activeTab = url.substring(url.indexOf("#") + 1);

      const activecollapsible = this.toggles.find(({ dataset }) => dataset.toggle === activeTab);

      if(activecollapsible){
        activecollapsible.click();
      }
    }
  }
  toggleMenu(collapsible){
    if(this.togglesMobile.length > 0){
      collapsible.style.transition = 'height .5s';
      collapsible.style.height = collapsible.offsetHeight === 0 ? `${collapsible.scrollHeight}px` : '0px';
    }
  }
}
customElements.define('tab-content', Tabs);



class DimensionTabs extends HTMLElement {
  constructor() {
    super();
    this.toggles = [...this.querySelectorAll('[data-dimension-toggle]')];
    this.collapsibles = [...this.querySelectorAll('[data-dimension-content]')];
    this.openMobile = this.querySelector('[data-trigger-mobile]');
    this.mobileContainer = this.querySelector('[data-trigger-container]');
    this.titleOption = [...this.querySelectorAll('[data-title-option]')];
    this.mobileToggles = [...this.querySelectorAll('[data-mobile-toggle]')];
    this.mobileCollapsibles = [...this.querySelectorAll('[data-mobile-content]')];
  }

  connectedCallback() {

    this.toggles?.forEach((btn) => {
      const id = btn.dataset.dimensionToggle;
      const collapsible = this.collapsibles.find(({ dataset }) => dataset.dimensionContent === id);
      btn.addEventListener('click', () => {
        this.toggles.forEach((tab)=>{
            tab.classList.remove('active');
        })
        btn.classList.add('active');
        this.titleOption?.forEach((t) => {
          t.innerHTML = btn.text;
        })
       
        // btn.addEventListener('click', () => {
        //   this.toggleMenu(collapsible);
        // });
        this.collapsibles.filter(({ dataset }) => dataset.dimensionContent !== id)
          .forEach((inactiveCollapsible) => {
            // eslint-disable-next-line no-param-reassign
            inactiveCollapsible.classList.add('hidden');
          });
          collapsible.classList.remove('hidden');
      });

    });

    
      this.openMobile.addEventListener('click', () => {
        this.mobileContainer.classList.toggle('hidden');
      });
      this.mobileToggles?.forEach((btn) => {
        const id = btn.dataset.mobileToggle;
        const collapsible = this.mobileCollapsibles.find(({ dataset }) => dataset.mobileContent === id);
        const icon = btn.querySelector('[data-icon]');
  
        btn.addEventListener('click', () => {
          collapsible.style.transition = 'height .5s';
          collapsible.style.height = collapsible.offsetHeight === 0 ? `${collapsible.scrollHeight}px` : '0px';
          icon.querySelector('span').classList.toggle('rotate-180');
          this.collapsibles.filter(({ dataset }) => dataset.mobileContent !== id)
            .forEach((inactiveCollapsible) => {
              // eslint-disable-next-line no-param-reassign
              inactiveCollapsible.style.height = '0px';
              inactiveCollapsible.parentNode.querySelector('[data-icon] span').classList.add('rotate-180');
            });
        });
      });
   

    //DEEP LINK
    let url = window.location.href;
    if (url.indexOf("#") > 0){
      const activeTab = url.substring(url.indexOf("#") + 1);

      const activecollapsible = this.toggles.find(({ dataset }) => dataset.toggle === activeTab);

      if(activecollapsible){
        activecollapsible.click();
      }
    }
  }
  toggleMenu(collapsible){
   
  }
}
customElements.define('dimension-tab', DimensionTabs);
